// ═══════════════════════════════════════════════════════════════════
//  composants/CrudModal.js
//  CrudModal
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { THEME } from "../socle/theme";
import { Field } from "./Field";
import { btnGhost, btnPrimary, inp, modalBox, modalOverlay } from "./styles";

export function CrudModal({ title, fields, initial, onClose, onSave }) {
  const build=()=>{ const o={}; fields.forEach((fl)=>{ let v=initial?.[fl.key]; if(fl.type==="date"&&v)v=String(v).slice(0,10); if(fl.type==="checkbox")v=!!v; o[fl.key]=v??(fl.type==="checkbox"?false:""); }); return o; };
  const [f,setF]=useState(build());
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>setF((p)=>({...p,[k]:v}));
  const save=async()=>{
    setSaving(true);
    const body={};
    fields.forEach((fl)=>{ let v=f[fl.key]; if(fl.numeric)v=v===""||v===null?null:Number(v); if(fl.type==="checkbox")v=v?1:0; if(v==="")v=null; body[fl.key]=v; });
    try{ await onSave(body); }catch{ alert("Enregistrement impossible (backend étape 4)."); }
    setSaving(false);
  };
  return (
    <div style={modalOverlay} onClick={onClose}>
      <div style={modalBox} onClick={(e)=>e.stopPropagation()}>
        <div style={{color:THEME.text,fontSize:16,fontWeight:800,marginBottom:16}}>{title}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          {fields.map((fl)=>(
            <Field key={fl.key} label={fl.label} full={fl.full}>
              {fl.type==="select" ? (
                <select value={f[fl.key]??""} onChange={(e)=>set(fl.key,e.target.value)} style={inp}>
                  <option value="">—</option>
                  {fl.options.map((o)=><option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              ) : fl.type==="textarea" ? (
                <textarea value={f[fl.key]??""} onChange={(e)=>set(fl.key,e.target.value)} style={{...inp,minHeight:60,resize:"vertical"}} />
              ) : fl.type==="checkbox" ? (
                <input type="checkbox" checked={!!f[fl.key]} onChange={(e)=>set(fl.key,e.target.checked)} style={{width:18,height:18}} />
              ) : (
                <input type={fl.type||"text"} step={fl.type==="number"?"0.01":undefined} value={f[fl.key]??""} onChange={(e)=>set(fl.key,e.target.value)} style={inp} placeholder={fl.placeholder||""} />
              )}
            </Field>
          ))}
        </div>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:18}}>
          <button onClick={onClose} style={btnGhost}>Annuler</button>
          <button onClick={save} disabled={saving} style={{...btnPrimary,opacity:saving?0.6:1}}>{saving?"…":"Enregistrer"}</button>
        </div>
      </div>
    </div>
  );
}
